import React, { useEffect, useState } from "react";
import axios from "axios";
import Dashboard from "./Dashboard";
import Header from "./Header";
import FilterPanel from "./FilterPanel";
import { Grid } from "@mui/material";


function LandingPage() {
  const [isLoadingVideos, setIsLoadingVideos] = useState(false);
  const [searchedVideos, setSearchedVideos] = useState([]);
  const [genreFilters, setGenreFilters] = useState(["All"]);
  const [ageGroups, setAgeGroups] = useState("All");
  const [searchText, setSearchText] = useState('');
  const [sortBy, setSortBy] = useState('releaseDate')
  const [debounceTimer, setDebounceTimer] = useState(0);

  const URL = "https://7168661e-436d-4a67-bc22-cb1049597751.mock.pstmn.io/v1";
  useEffect(() => {
    debounceSearch(searchText, genreFilters, ageGroups, sortBy);
  }, [searchText, genreFilters, ageGroups, sortBy]);

  const performSearch = async (searchText, genreFilters, ageGroups, sortBy) => {
    let searchString = "";
    if(genreFilters[0] === 'All' && ageGroups === 'All' && searchText === ''){
    searchString = `/videos?sortBy=${sortBy}`
  }else{
    const genresString = genreFilters.join();
    console.log("genresString", genresString);
    
    if (searchText === '') {
      searchString = `/videos?genres=${genresString}&contentRating=${ageGroups}&sortBy=${sortBy}`;
    } else {
      searchString = `/videos?title=${searchText}&genres=${genresString}&contentRating=${ageGroups}&sortBy=${sortBy}`;
    }
  }
    console.log("searchString", searchString);
    try {
      const searchedVideos = await axios.get(URL + searchString);
      console.log("searchedVideos.data", searchedVideos.data.videos);
      setSearchedVideos(searchedVideos.data.videos);
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log("A");
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        // console.log("B");
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    }
  };
  // Debounce timer

  const debounceSearch = (searchText, genreFilters, ageGroups, sortBy) => {
    console.log(
      "Searching for video with",
      searchText,
      genreFilters,
      ageGroups
    );

    if (debounceTimer !== 0) {
      clearTimeout(debounceTimer);
    }
    const newTimer = setTimeout(() => {
      performSearch(searchText, genreFilters, ageGroups, sortBy);
    }, 1500);

    setDebounceTimer(newTimer);
  };

  return (
    <>
      <Header
        performSearch={performSearch}
        setSearchText={setSearchText}
        searchText={searchText}
      />
      
      <FilterPanel
        sortBy={sortBy}
        setSortBy={setSortBy}
        setAgeGroups={setAgeGroups}
        ageGroups={ageGroups}
        setGenreFilters={setGenreFilters}
        genreFilters={genreFilters}
      />
      <Grid container justifyContent="center" alignItems="center">
      <Grid item xs={10} md={10} lg={10}>
      <Dashboard allVideos={searchedVideos} />
      </Grid>
      </Grid>
    </>
  );
}

export default LandingPage;
